import { AvailabilityCalendar } from '@/components/AvailabilityCalendar';

export default function DisponibilitaMedico() {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-[#1F2A37]" style={{ fontFamily: 'Space Grotesk' }}>La mia disponibilità</h2>
        <p className="text-muted-foreground">Gestisci i tuoi slot di disponibilità dal calendario oppure scrivili in linguaggio naturale all'assistente. Gli slot prenotati non sono eliminabili.</p>
      </div>
      <AvailabilityCalendar />
    </div>
  );
}
